import { useReferralPromo } from '../utils/referralUtils';

interface Props {
  ticketsSold: number;
  showTicketIcon?: boolean;
}

const OrderReferralProgressBar: React.FC<Props> = ({
  ticketsSold,
  showTicketIcon = false,
}) => {
  const promo = useReferralPromo(ticketsSold);

  return (
        <div className='flex flex-row gap-2'>
            <div className={`flex-1 ${showTicketIcon ? 'mr-2' : ''}`}>
                <div className="relative">
                    <div className="relative h-4 bg-surface-tertiary rounded-full border border-border-primary overflow-hidden">
                        <div
                            className="h-full transition-all duration-700 ease-in-out"
                            style={{
                              width: `${promo.overallProgress}%`,
                              background: 'linear-gradient(90deg, #BF1E62 0%, #F4B3DD 100%)',
                              borderRadius: '10px',
                            }}
                        ></div>
                        <div className="absolute inset-0">
                            {promo.milestones.map((m) => (
                                <div
                                    key={`mark-${m.tickets}`}
                                    className="absolute top-1/2 -translate-x-1/2 -translate-y-1/2"
                                    style={{ left: `calc(${(m.tickets / 10) * 100}% - 7px)` }}
                                >
                                    <div className={`w-4 h-4 rounded-full border ${promo.ticketsSold >= m.tickets ? 'hidden' : 'bg-surface-base border-border-primary'}`}></div>
                                </div>
                            ))}
                        </div>
                    </div>
                    {promo.overallProgress > 0 && <div
                        className="absolute top-0 -translate-y-1/4 -translate-x-1/2 w-8 h-8 rounded-full bg-secondary-100 opacity-50"
                      style={{ left: `calc(${promo.overallProgress}% - 4px)` }}
                        aria-hidden
                    ></div>}
                </div>
                <div className="relative h-10 hidden md:block mt-4">
                    {promo.milestones.map((m) => (
                        <div
                            key={`label-${m.tickets}`}
                            className="absolute -translate-x-1/2 text-center"
                            style={{ left: `calc(${(m.tickets / 10) * 100}% - 7px)` }}
                        >
                            <span className="block text-text-tertiary text-xs whitespace-nowrap">{m.tickets} entradas</span>
                            <span className="block text-text-primary text-sm font-medium">{m.percent}%</span>
                        </div>
                    ))}
                </div>
                <div className='grid grid-cols-4 gap-3 md:hidden mt-4'>
                    {promo.milestones.map((m) => (
                        <div key={`label-${m.tickets}`} className='flex flex-col items-center justify-center'>
                            <span className="block text-text-tertiary text-xs whitespace-nowrap">{m.tickets} entradas</span>
                            <span className="block text-text-primary text-sm font-medium">{m.percent}%</span>
                        </div>
                    ))}
                </div>
            </div>
            {showTicketIcon && (
                <img src="/ticket.svg" alt="" className='w-6 h-6 rotate-12 mt-[-4px]' />
            )}
        </div>
  );
};

export default OrderReferralProgressBar;
